<style lang="scss" scoped>
.create-form-contract {
  width: 100%;

  .form-group {
    margin-bottom: 0px;
  }

  .form-field {
    margin-bottom: 15px;
  }

  label {
    font-weight: 600;
  }

  .contract-left {
    float: left;
    width: 50%;
  }

  .required {
    color: #ff1a1a;
  }

  .contract-right {
    float: right;
    width: 50%;
  }

  .add-contract {
    clear: both;
    margin-left: 14px;
  }

  .information-contract {
    position: relative;
    clear: both;

    .form-field {
      float: left;
    }

    .delete-employee {
      position: absolute;
      display: block;
      right: 9%;
      top: 34px;
    }
  }

  .require {
    color: #ff1a1a;
  }

  .btn-add-employee {
    clear: both;
    margin-left: 14px;

    .btn-add-new label {
      color: #f6ab5f;
      font-size: 1rem;
      cursor: pointer;
    }
  }

  .contract.button {
    clear: both;

    .save-contract {
      background: #b4daf3;
      font-weight: 600;
      padding: 7px 70px;
      color: #0d2e48;
      margin: 40px 14px 0px;
      border: 2px solid #b4daf3;
    }

    .cancel-contract {
      margin-top: 40px;
      padding: 7px 45px;
      font-weight: 600;
      background: #f6f6f6;
      border: 2px solid #0d2e48;
      color: #0d2e48;
      max-width: 300px;
    }
  }
}

@media screen and (max-width: 767px) {
  .container-fluid {
    .contract.container {
      padding: 0;
      .create-form-contract {
        margin-right: 0px;

        .save-contract {
          width: 100%;
          margin: 0.625rem 0 0 0;
        }

        .cancel-contract {
          margin: 0.625rem 0 1rem 0;
          width: 100%;
          max-width: 100%;
        }

        .contract-left {
          padding: 0;
          clear: both;
          width: 100%;
        }

        .contract-right {
          padding: 0;
          clear: both;
          width: 100%;
        }

        .information-employee {
          .delete-employee {
            right: 0%;
          }
        }
        .form-field-mobile {
          padding: 0;
        }
        .add-contract,
        .btn-add-employee {
          margin: 12rem 0 0 0;
        }
        .btn-add-new {
          margin-top: 16rem;
        }
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .contract.container {
    max-width: 100%;
    padding: 0;
  }
}
</style>
<template>
  <CContainer class="contract">
    <ValidationObserver ref="formUpdateContract" v-slot="{ handleSubmit }">
      <CForm
        class="create-form-contract"
        @submit.prevent="handleSubmit(submitContract)"
      >
        <CCol md="12 form-field-mobile">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <h4>{{ $t("contract.update_contract") }}</h4>
          </CCol>
        </CCol>
        <CCol md="12" class="contract-left">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <label>
              {{ $t("employee.code_employee") }}
            </label>
            <CInput type="text" :disabled="true" :value="employee_id" />
          </CCol>
        </CCol>
        <CCol md="12" class="contract-right">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <label>
              {{ $t("placeholder.label_employee_search_name") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('placeholder.label_employee_search_name')"
            >
              <select
                class="form-control form-group"
                v-model="employee_id"
                :disabled="true"
              >
                <option
                  v-for="(option, index) in employees"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.text }}
                </option>
              </select>
              <span class="required">{{ $t(errors[0]) }}</span>
            </ValidationProvider>
          </CCol>
        </CCol>
        <CCol md="12" sm="12" class="form-field add-contract form-field-mobile">
          <h4>{{ $t("contract.add_contract") }}</h4>
        </CCol>
        <CCol md="12 form-field-mobile">
          <div
            v-for="(item, index) in employeeContractInfo"
            :key="index"
            class="customer-information"
          >
            <div class="information-contract">
              <CCol md="4" class="form-field form-field-mobile">
                <label>
                  {{ $t("contract.type_contract") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="
                    $t('contract.type_contract_position') +
                      ' ' +
                      getNumberRow(index)
                  "
                >
                  <select
                    class="form-control form-group"
                    v-model="employeeContractInfo[index].contract_code"
                  >
                    <option value="">{{ $t("employee.select_option") }}</option>
                    <option
                      v-for="(option, index) in contracts"
                      :key="index"
                      :value="option.code"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <CCol md="3" class="form-field form-field-mobile">
                <label>
                  {{ $t("additional_timeSheet.start_date") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  :rules="{
                    required: true,
                    check_format_start_date: true,
                    less_end_time: {
                      end_date: employeeContractInfo[index].end_date
                    }
                  }"
                  v-slot="{ errors }"
                  :name="
                    $t('contract.position_start_date') +
                      ' ' +
                      getNumberRow(index)
                  "
                >
                  <DatePickerFormFlex
                    :propsDate="employeeContractInfo[index].start_date"
                    @emitDate="startDate($event, index)"
                    v-model="employeeContractInfo[index].start_date"
                  />
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <CCol md="3" class="form-field form-field-mobile">
                <label>
                  {{ $t("additional_timeSheet.end_date") }}
                </label>
                <ValidationProvider
                  :rules="{
                    check_format_end_date: true,
                    fewer_start_time: {
                      start_date: employeeContractInfo[index].start_date
                    }
                  }"
                  v-slot="{ errors }"
                  :name="$t('additional_timeSheet.end_date')"
                >
                  <DatePickerFormFlex
                    :propsDate="employeeContractInfo[index].end_date"
                    @emitDate="endDate($event, index)"
                    v-model="employeeContractInfo[index].end_date"
                  />
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <span
                class="delete-employee"
                @click="deleteContract(index)"
                v-if="employeeContractInfo.length > 1"
              >
                <CIcon name="cilTrash" class="delete-btn" />
              </span>
            </div>
          </div>
        </CCol>
        <CCol
          md="10"
          sm="12"
          class="form-field btn-add-employee form-field-mobile"
        >
          <div class="btn-add-new">
            <label @click="addEmployeeContract()"
              >+ {{ $t("contract.add_contract") }}</label
            >
          </div>
        </CCol>
        <CCol md="12" sm="12" class="contract button">
          <CButton type="submit" class="save-contract"
            >{{ $t("label.save_infomation") }}
          </CButton>
          <CButton class="cancel-contract" type="button" @click="cancel()"
            >{{ $t("contract.cancel_contract") }}
          </CButton>
        </CCol>
      </CForm>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_contract_update"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerFormFlex
  },

  async created() {
    this.idEmployee = this.$route.params.id;
    if (this.idEmployee) {
      await this.$store.dispatch("contract-employee/getCommonsData");
      await this.$store.dispatch(
        "contract-employee/getInfoEmployeeContract",
        this.idEmployee
      );
      if (this.employeeContractInfo.length === 0) {
        this.$router.push({ path: "/contracts" });
      }
    }
  },

  computed: {
    ...mapGetters({
      employees: "contract-employee/employees",
      contracts: "contract-employee/contracts",
      employee_id: "contract-employee/employee_id",
      employeeContractInfo: "contract-employee/employeeContractInfo"
    })
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    startDate(data, index) {
      this.employeeContractInfo[index].start_date = data;
    },

    endDate(data, index) {
      this.employeeContractInfo[index].end_date = data;
    },

    getNumberRow(index) {
      return index + 1;
    },

    async submitContract() {
      this.setLoading(true);
      this.employeeContractInfo.employee_id = this.employee_id;
      await this.$store
        .dispatch(
          "contract-employee/updateContractEmployee",
          this.employeeContractInfo
        )
        .then(() => {
          let message = this.$t("contract.popup.update_contract_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/contracts" });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    addEmployeeContract() {
      this.employeeContractInfo.push({
        contract_code: "",
        start_date: Intl.DateTimeFormat("en-GB").format(new Date()),
        end_date: Intl.DateTimeFormat("en-GB").format(new Date())
      });
    },

    deleteContract(index) {
      this.employeeContractInfo.splice(index, 1);
    },

    cancel() {
      this.$confirm(
        this.$t("contract.cancel_update_contract"),
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/contracts" });
        }
      });
    }
  }
};
</script>

<style>
.delete-btn {
  color: red;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

.select2-container {
  width: 100% !important;
}
</style>
